import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { Box, Flex, Heading, IconButton, Text, VStack } from '@chakra-ui/react'

export default function Header({ isLoading = false, onRefresh = null, isPulling = false }) {
  const navigate = useNavigate()
  const location = useLocation()
  const isAccountsPage = location.pathname === '/app/accounts'

  return (
    <Box as="header" mb={isLoading ? 0 : 4} position="relative">
      <Flex align="center" justify="center" position="relative">
        {!isAccountsPage && onRefresh && (
          <IconButton
            icon={<span>â†»</span>}
            onClick={() => onRefresh && onRefresh()}
            aria-label="Refresh feed"
            title="Refresh feed"
            variant="ghost"
            colorScheme="brand"
            size="lg"
            fontSize="20px"
            position="absolute"
            left={0}
            top={0}
            isLoading={isPulling}
            _hover={{ bg: 'whiteAlpha.100' }}
          />
        )}
        
        {!isAccountsPage && (
          <VStack spacing={1}>
            <Heading 
              as="h1" 
              size="xl" 
              fontWeight="500"
              letterSpacing="-0.01em"
              color="#fafafa"
              whiteSpace="nowrap"
            >
              First Signal
            </Heading>
            <Text
              fontSize="sm"
              color="#22c55e"
              fontWeight="400"
              letterSpacing="0.02em"
              id="status"
            >
              Connectingâ€¦
            </Text>
          </VStack>
        )}

        {!isAccountsPage && !isLoading && (
          <IconButton
            icon={<span>âš™ï¸</span>}
            onClick={() => navigate('/app/accounts')}
            aria-label="Manage Accounts"
            title="Manage Accounts"
            variant="ghost"
            colorScheme="brand"
            size="lg"
            fontSize="20px"
            position="absolute"
            right={0}
            top={0}
            _hover={{ bg: 'whiteAlpha.100' }}
          />
        )}
      </Flex>
    </Box>
  )
}
